<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="qualityControl-box">
      <div class="center-box">
        <div class="crumbs">首页 > 指南共识 > 指南共识详情</div>
        <!-- 渲染富文本内容 -->
        <!-- <div class="richText" v-if="imageType === 0 || imageType === 3" v-html="newsContent"></div> -->
        <div class="richText-content" v-if="imageType === 0 || imageType === 3">
          <quill-editor v-model:content="newsContent" :options="editorOption" contentType="html" readonly @focus="onEditorFocus($event)" @change="onEditorChange($event)" />
        </div>
        <div class="video-box" v-if="imageType === 1">
          <video :src="videoUrl.url" controls />
        </div>
        <div class="margin-top" v-if="imageType === 2 || imageType === 3 || imageType === 4">
          <div v-for="(item, index) in pdfContent" :key="index">
            <VueOfficePdf v-if="imageType === 2 || imageType === 3" :src="item.url" />
            <VueOfficeDocx v-else-if="imageType === 4" :src="item.url" />
          </div>
        </div>
        <!-- <iframe class="richText" :src="newsContent" id=""></iframe> -->
        <informationBottom :detailsInfo="detailsInfo" :id="id" @getPageDetails="getPageDetails"></informationBottom>
      </div>
    </div>
    <!---->

    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import course from "@/components/base/course";
import comment from "@/components/base/comment"
import informationBottom from "@/components/base/informationBottom"
import { getPageDetails } from '@/api/home'
import VueOfficePdf from "@vue-office/pdf";
import VueOfficeDocx from "@vue-office/docx";
// 引入vue-quill-editor
import { quillEditor } from "vue-quill-editor";
// 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav, course, comment, VueOfficePdf, VueOfficeDocx, quillEditor, informationBottom },
  data() {
    return {
      selectedIndex: 7,
      newsContent: '', // 用来存储富文本内容
      id: '',
      imageType: '',
      videoUrl: {}, // 视频链接
      pdfContent: [],
      editorOption: {
        theme: 'snow', // 主题风格
        modules: {
          toolbar: false, // 设置为false以隐藏工具栏
        },
        readOnly: true, // 禁止编辑
        // bounds: document.body,
        debug: 'warn',
      },
      detailsInfo: {},
    }
  },
  methods: {
    onEditorFocus(editor) {
      editor.enable(false);
    },
    onEditorChange(editor) {
      editor.quill.enable(false);
    },
    // 模拟获取富文本的内容
    fetchNewsContent() {
      // 模拟从后端获取富文本内容
      // 这里假设从后端接口获取到了 HTML 格式的富文本
      const imageUrl = require('@/assets/images/z1.png');
      const content = `
          <h2>新闻标题</h2>
          <p>这是新闻的详细内容。</p>
          <p><strong>这是一段加粗的文字</strong></p>
          <img src="${imageUrl}" alt="示例图片"/>
          <p>新闻结束，更多内容请关注官网。</p>
        `;
      this.newsContent = content; // 将内容赋值给 newsContent
    },
    // 按 id 查询新闻资讯、质控课程、质控公告
    getPageDetails() {
      getPageDetails({
        id: this.id
      }).then(res => {
        this.imageType = res.data[0].imageType
        this.detailsInfo = res.data[0]
        // this.newsContent = res.data[0].contentHtml.url
        if (this.imageType === 1) {
          this.videoUrl = res.data[0].video
        } else if (this.imageType === 2) {
          this.pdfContent = res.data[0].pdfFile
        } else if (this.imageType === 3) {
          this.newsContent = res.data[0].htmlContent
          this.pdfContent = res.data[0].pdfFile
        } else if (this.imageType === 4) {
          this.pdfContent = res.data[0].wordFile
        } else if (this.imageType === 0) {
          this.newsContent = res.data[0].htmlContent
        }
      })
    },
  },
  mounted() {
    // this.fetchNewsContent(); // 页面加载后获取富文本内容
    console.log(this.$route.params, 'this.$route.params')
    var wow = new this.$wow.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
    this.id = this.$route.params.id
    this.getPageDetails()
  }
}
</script>

<style lang="less" scoped>
.margin-top {
  margin-top: 18px;
}

.qualityControl-box {
  flex: 1;
  overflow: hidden;
}

.center-box {
  padding-bottom: 80px;

  .video-box {
    width: 100%;
    height: 700px;
    background: #000000;
    margin-top: 18px;
    padding: 20px;
    box-sizing: border-box;

    video {
      height: 100%;
      width: auto;
    }
  }
}

.richText-content {
  background-color: #FFFFFF;
  margin-top: 18px;
  padding: 40px;

  /deep/ .ql-container.ql-snow {
    border: none;
  }
}

.richText {
  background: #fff;
  border-radius: 6px;
  padding: 40px 60px;
  margin-top: 18px;

  /deep/img {
    max-width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/NewsDetailsThree/index.vue